var _style, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhoneCallIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "svg2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 302 302",
    style: {
      enableBackground: "new 0 0 302 302"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#FFFFFF;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "path2232",
    className: "st0",
    d: " M193.8,246.8c8.5-2.6,17.8-6.2,20.9-8.1c2.1-1.2,2.4-1.7,1.7-2.4c-5.3-5.1-42.2-37.5-42.6-37.3c-0.2,0.1-0.8,2.5-1.3,5.1 c-1,5.3-1.9,6.5-5,6.5c-2.5,0-4.2-1.4-6.6-5.6c-1.1-1.8-2.8-4.4-3.8-5.7c-1-1.3-3.1-4.6-4.6-7.3c-1.5-2.7-4.2-7.2-5.9-9.9 c-4-6.3-8.6-14-10.4-17.2c-0.7-1.4-2.6-4.1-4.1-6.2c-1.5-2-3.4-5-4.2-6.7s-3.2-5.5-5.3-8.7c-2.1-3.1-4.6-7.3-5.6-9.2 c-1-1.9-2.8-5.1-4-7c-2.8-4.4-6.1-10.9-6.6-13.3c-0.3-1.4-0.1-2.2,1.4-3.5c2-1.9,2.1-1.9,8.4,0c2.1,0.6,4,1,4.2,0.9 c0.3-0.3-14-55.8-14.5-56.3c-0.4-0.4-17.1,13.7-17.1,14.4c0,0.3-1.5,2-3.2,3.8c-1.8,1.8-4.3,4.9-5.6,7c-2.1,3.3-2.5,4.7-3.1,10.3 c-2,18,2.7,44.7,11.8,65.9c4.9,11.4,7.8,17.1,11.2,22c1.6,2.2,3.7,5.7,4.7,7.7c5.4,10.8,22.4,30.6,34.3,39.8 c8.2,6.4,25.6,17.7,29.6,19.4C179.9,250,183,250.2,193.8,246.8L193.8,246.8z M223.8,226.4c2.6-6.3,2.6-6.6,1.5-7.7 c-0.9-0.9-30.8-26.9-34.9-30.4c-1-0.8-1.9-0.5-7.9,2.5c-5.7,2.9-6.7,3.6-5.9,4.3c2.8,2.7,44.2,38.3,44.4,38.1 C221,233,222.3,230,223.8,226.4L223.8,226.4z M132,106.5c2.8-2.2,5.1-4,5.1-4c-0.8-3.6-11.9-47.3-12.1-47.5 c-0.4-0.4-14.6-2.4-14.9-2.1c-0.2,0.2,3.7,15.3,14.5,56C125.3,111.8,124.8,111.9,132,106.5L132,106.5z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneCallIcon);
export default __webpack_public_path__ + "static/media/phone-call-icon.4836b6429acd883ec589c5c51b51a6f6.svg";
export { ForwardRef as ReactComponent };